export type ErrorSeverity = 'info' | 'warning' | 'error' | 'fatal';
export type ErrorSource = 'http' | 'runtime' | 'validation' | 'business';


export interface AppError {
    id: string;
    message: string;
    severity: ErrorSeverity;
    source: ErrorSource;
    statusCode?: number;
    timestamp: Date;
    context?: string;
    originalError?: unknown;
}

export interface HttpErrorContext {
    url: string;
    method: string;
    statusCode: number;
}

/*
Omit è un utility type di TypeScript che costruisce un nuovo tipo partendo da uno esistente, ma rimuovendo i campi che gli dici tu.
In questo caso i campi sono if e timestamp
*/
export function createAppError(
    partial: Omit<AppError, 'id' | 'timestamp'>
): AppError {
    return {
        ...partial,
        id: crypto.randomUUID(),
        timestamp: new Date(),
    };
}

